/**
 * TanStack Query hook for `GET /api/cro/metrics/pacing/CRO-01` (Phase 04.1 #5).
 *
 * Feeds the CRO-01 cumulative-ARR line chart (current-FY actual vs on-pace vs
 * prior-FY actual + remaining-to-target). Mirrors useCroScorecard config.
 */
import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiFetch } from '../lib/api-client.js';

import type { MetricError } from './useCroScorecard.js';
import type { CroArrPacingResponse } from '@saledash/shared';

export function useCroArrPacing(): UseQueryResult<CroArrPacingResponse, MetricError> {
  return useQuery<CroArrPacingResponse, MetricError>({
    queryKey: ['cro', 'pacing', 'CRO-01'],
    queryFn: ({ signal }) =>
      apiFetch<CroArrPacingResponse>('/api/cro/metrics/pacing/CRO-01', { signal }),
    staleTime: 60_000,
    retry: 2,
  });
}
